import { render, staticRenderFns } from "./NetsisPuantaj.vue?vue&type=template&id=38492dbf&"
import script from "./NetsisPuantaj.vue?vue&type=script&lang=js&"
export * from "./NetsisPuantaj.vue?vue&type=script&lang=js&"
import style0 from "./NetsisPuantaj.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports